import {AuthoritiesMap} from "@context/appContext/types/appContext";

export const buildAuthoritiesMap = (authorities:string[])=>{
    if(!authorities?.length){
        return {}
    }
    const res:AuthoritiesMap = {}

    authorities.forEach((key)=>{
        res[key] = true
    })

    return  res;

}